const BrowserFileListReducer = (
  state = {
    loading: false,
    browserFile: [],
    totalRecords: 0,
    msg: "",
  },
  action
) => {
  switch (action.type) {
    case "FETCH_BROWSER_FILE_LIST":
      return {
        ...state,
        loading: true,
        browserFile: [],
        totalRecords: 0,
        msg: "",
      };
    case "RECEIVE_BROWSER_FILE_LIST":
      return {
        ...state,
        browserFile: [...action?.payload?.data],
        loading: false,
        totalRecords: action.payload.totalRecords,
        msg: "",
      };
    case "ERROR_BROWSER_FILE_LIST":
      return {
        ...state,
        browserFile: [],
        loading: true,
        totalRecords: 0,
        msg: action.payload,
      };
    default:
      return { ...state };
  }
};

export default BrowserFileListReducer;
